export default {
  test: {},
  hide: { display: 'none' }
};